import {
  Controls,
  InstrumentPanel,
  QuickViewControls,
} from 'lib-analytics-types';
import pick from 'lodash/pick';

export function mergePanelAndQuickViewControls(
  panel: InstrumentPanel,
  quickViewControls: QuickViewControls,
): Controls {
  return {
    ...panel.controls!,
    ...quickViewControls,
    settings: {
      ...panel.controls!.settings,
      // Overwrite panel settings with global period settings to ensure consistency
      // between what is selected in the global period control and the resulting metrics.
      ...pick(quickViewControls?.settings, 'timezone', 'schedule_id'),
    },
  };
}
